const initialState = {
  list: [],
};

export default function sessionsReducer(state = initialState, action) {
  switch (action.type) {
    case 'sessions/set':
      return { ...state, list: action.payload || [] };
    default:
      return state;
  }
}

export function setSessionsList(payload) {
  return { type: 'sessions/set', payload };
}
